import { Store } from '@reduxjs/toolkit';

import { setAuth } from '../../app/consumerInfoSlice';
import { store } from '../../app/store';
import {
  ApiRequest,
  ApiResponse,
  getHandler,
  handleApiError,
  Handler,
} from '../../types/Api';
import { API_CONFIG, RequestName } from '../api.types';
import { httpRequest } from '../http/client';
import { ResponseCode } from '../http/httpConsts';

interface CreatePinResponse {
  token: string;
}

export const handleOk = async (
  store: Store,
  response: ApiResponse,
  params?: { onSuccess: () => void; onFail: () => void }
) => {
  const res = response.data.body as CreatePinResponse;
  const dispatch = store.dispatch;
  const auth = store.getState().consumerInfoSelector.auth;

  dispatch(
    setAuth({
      ...auth,
      token: res.token,
      lastActive: new Date().toString(),
    })
  );

  params?.onSuccess();
};

const handleGenericError = (
  store: Store,
  response: ApiResponse,
  params?: { onSuccess: () => void; onFail: () => void }
) => {
  const res = response.data.body as ApiResponse;

  params?.onFail();
  handleApiError(RequestName.CREATE_PIN, res);
};

const handlers: Handler = {
  [ResponseCode.OK]: handleOk,
};

export interface CreatePinParams {
  pin: string;
  onSuccess: () => void;
  onFail: () => void;
}

export const createPin = async ({
  pin,
  onSuccess,
  onFail,
}: CreatePinParams) => {
  const { requestID } = store.getState().consumerInfoSelector.auth;

  const body = {
    pin,
    requestID,
  };

  const req = {
    config: API_CONFIG.CREATE_PIN,
    body,
  } as ApiRequest;
  const apiResponse = await httpRequest(req);

  const handler = getHandler(apiResponse.status, handlers, handleGenericError);
  handler(store, apiResponse, { onSuccess, onFail });
};
